import React from 'react';
import { Box, Card, CardContent, Typography, Collapse, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { formatDateTime } from '../../../../../services/functions';
import { useEmployees } from '../../EmployessContext';


function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="left">{formatDateTime(row.created_at)}</TableCell>
        <TableCell align="left">{row.pl_type_name}</TableCell>
        <TableCell align="left">{row.username}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Historia
              </Typography>
              <Card>
                <CardContent>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">Nazwa pola</TableCell>
                          <TableCell align="left">Przed</TableCell>
                          <TableCell align="left">Po</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Object.keys(row.json_message).map(key => {
                          let str = row.json_message[key];

                          const name = str.slice(0, str.indexOf(':'));
                          str = str.replace(`${name}:`, '');
                          let valueBefore = '';
                          let valueAfter = '';

                          if (str.indexOf('->') !== -1) {
                            valueBefore = str.slice(0, str.indexOf('->'));
                            valueAfter = str.slice(str.indexOf('->') + 2);
                          } else {
                            valueAfter = str;
                          }

                          return <TableRow key={key}>
                            <TableCell align="left" sx={{ whiteSpace: 'pre-line' }}>{name}</TableCell>
                            <TableCell align="left" sx={{ whiteSpace: 'pre-line' }}>{valueBefore}</TableCell>
                            <TableCell align="left" sx={{ whiteSpace: 'pre-line' }}>{valueAfter}</TableCell>
                          </TableRow>;
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const ChangeHistory = () => {
  const { rowData } = useEmployees();

  return (
    <Box display="flex" flexDirection="column" mt={1}>
      <Card>
        <CardContent>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell align="left">Data</TableCell>
                  <TableCell align="left">Rodzaj operacji</TableCell>
                  <TableCell align="left">Użytkownik</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rowData.history_list !== undefined ? rowData.history_list.map(row => (
                  <Row key={row.id} row={row}/>
                )) : null}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};


export default ChangeHistory;
